import React, { useState } from "react";
import { Box, Typography, Tabs, Tab } from "@mui/material";
import { styled } from "@mui/system";
import {
  StyledSideBarHeader,
} from "../../../common/StyledComponents/SideBarComponents";
import ExploreVideoFilter from "./ExploreVideoFilter";
import ExplorePhotoFilter from "./ExplorePhotoFilter";
const StyledSubHeadingBox = styled(Box)({
  display: "flex",
  alignItems: "center",
  // backgroundColor: "#F3F3F3",
  marginBottom: "0.5rem",
});
const classes = {
  chatBox1: {
    minWidth: "280px",
    backgroundColor: "#efefef",
    height: "calc(100vh - 64px)",
    width: "calc(100% - 71.7em)",
    maxWidth: "500px",
    "@media only screen and (max-width:900px)": {
      flex: "1",
    },
  },
  chatBox2: {
    backgroundColor: "#efefef",
    height: "calc(100vh - 64px)",
    minWidth: "250px",
    maxWidth: "350px",

    "@media only screen and (max-width:900px)": {
      flex: "1",
    },
  },
  Tabs: {
    minHeight: "38px",
    width: "fit-content",
    "& .MuiTabs-flexContainer": {
      justifyContent: "flex-start",
      gap: "1rem",
    },
    "& .css-jpln7h-MuiTabs-scroller": {
      overflow: "auto !important",
      "&::-webkit-scrollbar": {
        height: "0px",
      },
      "&::-webkit-scrollbar-track": {
        background: "#f1f1f1",
      },
      "&::-webkit-scrollbar-thumb": {
        background: "#888",
      },
    },
    "@media (max-width: 63em)": {
      "& .MuiTabs-flexContainer": {},
    },
  },
  tabs: {
    color: "black",
    padding: "0px 0px",
    textTransform: "none",
    minWidth: "fit-content",
    minHeight: "2.2rem",
    "&.Mui-selected": {
      color: "black",
    },
    "@media (max-width: 64em)": {
      // marginRight: "2.5rem",
    },
  },
  headingText: {
    color: "black",
    fontSize: "14px",
    fontWeight: "400",
    "@media (max-width: 63em)": {
      fontSize: "0.8rem",
    },
  },

  selectedItem: {
    backgroundColor: "#E1E1E1",
    color: "#000",
  },
  nonselectedItem: {
    color: "#000",
  },
  taskmargin: {
    display: "flex",
    display: "-webkit-box",
    display: "-ms-flexbox",
    display: "-webkit-flex",
    "-webkit-flex-direction": "row",
    "-ms-flex-direction": "row",
    flexDirection: "row",
    "-webkit-box-align": "center",
    "-ms-flex-align": "center",
    alignItems: "center",

    "@media only screen and (max-width:63em)": {
      marginLeft: "0 0px",
    },
  },
  checklabel: {
    marginRight: "0",
  },

  sidebar: {
    padding: "0px 20px 9px 30px",
    "@media (max-width: 85.5em)": {
      padding: "4px 8px 4px 8px",
    },
  },
  ckeckboxH: {
    height: "calc(100vh - 15.5rem)",
    overflow: "auto",
    "@media only screen and (min-width: 1600px)": {
      height: "calc(100vh - 18rem)",
    },
  },
  topindication: {
    padding: "0.5rem 0.5rem",
    marginTop: "3px",
    backgroundColor: "#F3F3F3",
    borderRadius: "0.1rem",
    fontSize: "13px !important",
  },
};
const Sidebar = ({
  clearFilter,
  handleFilter,
  filterSwitchLoading,
  setSideBarOpen,
  isSideBarOpen,
  checked,
  setChecked,
}) => {
  const [taskApprovalViewValue, setTaskApprovalViewValue] = useState(0);
  const handleViewChange = (event, newValue) => {
    setChecked([]);
    setTaskApprovalViewValue(newValue);
  };
  const TabPanel = ({ children, value, index }) => (
    <Box sx={{ display: value !== index ? "none" : "flex", flex: 1, minHeight: 0, flexDirection: "column" }}>
      {children}
    </Box>
  );

  return (
    <Box sx={{ height: "100%", display: "flex", flexDirection: "column" }}>
      <StyledSideBarHeader position={"relative"}>
        <Box
          display="flex"
          alignItems="center"
          justifyContent={"flex-start"}
          width={"100%"}
        >
          <Typography sx={classes.headingText} variant="h6">
            Filter
          </Typography>
        </Box>
      </StyledSideBarHeader>

      <Box
        sx={{
          flex: 1,
          minHeight: 0,
          display: "flex",
          flexDirection: "column",
          padding: "0px 20px 0px 30px",
          "@media (max-width: 85.5em)": { padding: "4px 8px 4px 8px" },
        }}
      >
        <Tabs
          value={taskApprovalViewValue}
          onChange={handleViewChange}
          TabIndicatorProps={{ style: { backgroundColor: "#183243" } }}
          sx={classes.Tabs}
        >
          <Tab disableRipple sx={classes.tabs} label="Videos" />
          <Tab disableRipple sx={classes.tabs} label="Photos" />
        </Tabs>

        <Box sx={{ flex: 1, minHeight: 0, display: "flex", flexDirection: "column" }}>
          <TabPanel value={taskApprovalViewValue} index={0}>
            <ExploreVideoFilter
              handleFilter={handleFilter}
              clearFilter={clearFilter}
              checked={checked}
              setChecked={setChecked}
            />
          </TabPanel>
          <TabPanel value={taskApprovalViewValue} index={1}>
            <ExplorePhotoFilter
              handleFilter={handleFilter}
              clearFilter={clearFilter}
              checked={checked}
              setChecked={setChecked}
            />
          </TabPanel>
        </Box>
      </Box>
    </Box>
  );
};

export default Sidebar;
